/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Select_List_LabelInputs */



/**
* | output |
* | --- |
* | "Select marker list" |
*
* @param {Markers_Select_List_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_select_list_label = /** @type {((inputs?: Markers_Select_List_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Select_List_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner la liste de marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Markerliste auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona l'elenco dei marcatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите список маркеров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar lista de marcadores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择标记列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカーリストを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर सूची का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lista de marcadores selecionada")
	return /** @type {LocalizedString} */ ("Select marker list")
});